module.exports = __webpack_public_path__ + "static/media/icon_react.82a318cc.png";